import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsbFormControlComponent } from './bsb-form-control.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [BsbFormControlComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatIconModule,
  ],
  exports: [BsbFormControlComponent],
})
export class BsbFormControlModule {}
